var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("v-data-table", {
        attrs: {
          search: _vm.search,
          loading: _vm.loading,
          headers: _vm.headers,
          items: _vm.redirects
        },
        scopedSlots: _vm._u([
          {
            key: "item.actions",
            fn: function fn(_ref) {
              var item = _ref.item
              return [
                _c(
                  "gg-btn",
                  {
                    on: {
                      click: function click($event) {
                        return _vm.openModal("delete", item)
                      }
                    }
                  },
                  [_vm._v(" Delete ")]
                )
              ]
            }
          }
        ])
      }),
      _c("delete-redirect-modal", {
        attrs: {
          opened: _vm.modals.delete,
          redirect: _vm.selectedItem
        },
        on: {
          "redirect-deleted": _vm.loadData,
          close: function close($event) {
            return _vm.closeModal("delete")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }